/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as Delivery from './trans-website-checkout-summarybox-delivery';

export const AcceptTerms = 'Website.Checkout.SummaryBox.AcceptTerms';
export const OrderCommentDeliveryDisclaimer = 'Website.Checkout.SummaryBox.OrderCommentDeliveryDisclaimer';
export const HideSummaryAccordion = 'Website.Checkout.SummaryBox.HideSummaryAccordion';
export const ShowSummaryAccordion = 'Website.Checkout.SummaryBox.ShowSummaryAccordion';
